import { mitoPalettes } from "./tokens";

/** Trust / MITO-orange — brand red-orange used on trust.mito.money. */
export const mitoOrangeTheme = mitoPalettes.orange;

export default mitoOrangeTheme;
